enum ApiFormat {
  D_FORMAT = 'D_FORMAT',
  C_FORMAT = 'C_FORMAT'
}

export enum SubTab {
  MAIN = 'TRMAIN',
  ASIA = 'TRASIA',
  G11 = 'TRG11',
  CROSS = 'TRCROSS',
  ALL = 'ALLFX'
}

export const TABS = [
  { label: '行情', value: ApiFormat.D_FORMAT },
  { label: '績效', value: ApiFormat.C_FORMAT }
];

export const SUB_TABS = [
  { label: '主要', value: SubTab.MAIN },
  { label: '亞洲', value: SubTab.ASIA },
  { label: 'G11', value: SubTab.G11 },
  { label: '交叉', value: SubTab.CROSS },
  { label: '全球', value: SubTab.ALL }
];
